import { Outlet } from "react-router-dom";
import AppLayout from "@/layouts/AppLayout";

export default function OrderIdLayout() {
  return (
    <AppLayout navLinks={[]} interior bottomBar>
      <div data-testid="order-detail-page">
        <Outlet />
      </div>
    </AppLayout>
  );
}
